// extracted by mini-css-extract-plugin
export var emptyState = "_6f-d";
export var statCard = "_6f-c";
export var table = "_6f-0";
export var tableCell = "_6f-4";
export var tableCellClickable = "_6f-5 _6f-4";
export var tableCellDefault = "_6f-6 _6f-4";
export var tableCellEmpty = "_6f-8";
export var tableCellWithValue = "_6f-7";
export var tableContainer = "_6f-e";
export var tableHeaderWeight = "_6f-1";
export var tableHeaderZone = "_6f-2";
export var tableRowHeader = "_6f-3";
export var viewModeButton = "_6f-9";
export var viewModeButtonActive = "_6f-a _6f-9";
export var viewModeButtonInactive = "_6f-b _6f-9";